const ApiPath = {
  // 课程中心 科目列表接口 【在线课程|章节练习|模拟考试】
  CourseCenter: '/v1/api/user/getSubjectLists',

  // 课程章节列表 【在线课程|章节练习】
  CourseChapterLists: '/v1/api/user/getChapterLists',
  // SubjectChapterLists: "/api/subject-chapter-lists",

  //// 在线课程
  // 在线课程详情页
  CourseChapterDetails: '/v1/api/user/getCourseInfo',
  CourseChapterDetailsPlayAuth: '/v1/api/user/getPlayVideoAuth',
  CourseChapterDetailsPlayUrl: '/v1/api/user/getPlayVideoUrl',
  CourseChapterDetailsItemRecord: '/v1/api/user/recordSubjectHit',
  CourseChapterDetailsRecordCourse: '/v1/api/user/recordCourse',

  //// 章节练习
  // 判断是否有章节练习的记录
  SubjectPracticeHistory: '/v1/api/user/checkPreviousPractise',
  // 章节练习详情页
  SubjectChapterDetails: '/v1/api/user/getExercises',
  // 章节练习详情页 多选题
  SubjectChapterCheckboxList: '/v1/api/user/getMoreCheckList',
  // 记录章节练习的位置
  SubjectPracticePositionSave: '/v1/api/user/recordQuitPosition',

  //// 模拟考试
  // 判断是否有模拟考试的记录
  MockTestHistory: '/v1/api/user/checkPreviousExamination',
  // 获取模拟试卷接口
  MockTestDetails: '/v1/api/user/generatingExamination',
  // 模拟卷考试题回答提交接口(一题一交)
  MockTestSubmit: '/v1/api/user/saveAnswerResults',
  // 模拟卷考试题回答提交接口(一题一交)
  MockTestAnswerStatistic: '/v1/api/user/answerStatistics',

  //// 个人中心
  // 微信个人信息
  IsLogin: '/v1/api/user/is_login',
  WechatUserInfo: '/v1/api/user/fetchWeChatPersonalInfo',
  HasIDCard: '/v1/api/orders/hasIDCard',

  // 判断是否是学生
  IsStudent: '/v1/api/user/inspectionAuthorization',

  // 发送手机号 获取验证码
  PhoneSignUpCode: '/v1/api/user/sendBindingMessage',

  // 输入验证码后， 发送验证
  PhoneSignUpVerify: '/v1/api/user/userBinding',

  // 考试记录
  MockTestRecordsHistoryList: '/v1/api/user/examinationRecord',
  MockTestRecordsHistoryDetails: '/v1/api/user/examinationRecordInfo',

  // 错题集
  MistakeCollectionList: '/v1/api/user/problemsWarehouse',
  MistakeCollectionDetails: '/v1/api/user/problemsWarehouseInfo',

  //// 在线购买
  // 获取购买信息
  OrderGetPayInfo: '/v1/api/orders/getSetTime',
  // 生成订单
  OrderGenerate: '/v1/api/orders/order',
  // 支付
  OrderPay: 'http://edu.dxxf119.cn/v1/api/orders/pay',
  //订单列表
  OrderList: '/v1/api/orders/orderList',
  // 获得历史真题列表
  PassedYearsExamination: 'v1/api/passedYears/getList',
  // 获取模拟/结业/历年真题考试/章节练习试卷
  GeneratingExamination: '/v1/api/user/generatingExamination',
  // 保存答题记录（回答一题保存一题）
  SaveAnswerResults: '/v1/api/user/saveAnswerResults', //证书列表
  // 证书列表
  CertList: '/v1/api/cert/list',
  //获取证书信息
  CertDetail: '/v1/api/cert/detail',
  //获取科目分类
  UserGetSubjectCategories: '/v1/api/user/getSubjectCategories',
  //文件上传
  Upload: '/v1/api/upload',
  //获取教师信息
  TeacherDetail: '/v1/api/teacher/detail',
  //保存报名信息
  SignupSave: '/V1/api/signup/save',
  // 国考复训科目
  nationalgetSubjects: '/v1/api/national/getSubjects',
  nationalgetCourseInfo: '/v1/api/national/getCourseInfo',
  nationalcheckPreviousRandomExamination:
    '/v1/api/national/checkPreviousRandomExamination',
  nationalgeneratingRandomExamination:
    '/v1/api/national/generatingRandomExamination',
  nationalsaveAnswerResults: '/v1/api/national/saveAnswerResults',
  nationalanswerStatistics: '/v1/api/national/answerStatistics',
  nationalRecordCourse: '/v1/api/national/recordCourse',
  nationalExaminationRecordInfo: '/v1/api/national/examinationRecordInfo',
  signupSubjects: '/v1/api/signup/subjects',
}

export default ApiPath
